<!-- 我的物流 -->
<template>
  <div
    :class="['myExpress', { inApp: $root.$data.isApp || this.$root.miniprogram || fromBiliOrder }]"
  >
    <common-title
      v-if="!fromBiliOrder"
      titleName="快递列表"
      :bcColor="'#fafafa'"
      :zIndex="1000"
    ></common-title>
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      :disabled="disabled"
      v-if="expressList.length"
    >
      <h1 class="handout-title">我的发货快递</h1>
      <section>
        <van-list v-model="loading" :finished="finished" :immediate-check="false" @load="onLoad">
          <ul class="logistics-list">
            <li v-for="(item, index) in expressList" :key="index">
              <p class="time">{{ item.deliveryTime.slice(0, 11) }}</p>
              <LogisticsCard :info="item" @setDisabled="setDisabled" />
            </li>
          </ul>
        </van-list>
      </section>
    </van-pull-refresh>
    <EmptyData v-if="!expressList.length" :emptyName="'businessOrder'" />
  </div>
</template>

<script>
import { reqExpressList } from '@/api/personal/logistics/index';
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import LogisticsCard from './component/logisticsCard.vue';

export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 10000,
      expressList: [], // 物流列表
      loading: false,
      finished: false,
      refreshing: false,
      disabled: false,
      fromBiliOrder: this.$route.query.iqhId || '',
    };
  },
  watch: {},
  components: {
    CommonTitle,
    LogisticsCard,
    EmptyData,
  },

  computed: {},

  mounted() {
    document.title = '快递列表';
  },

  created() {
    this.getExpress(this.pageNum, this.pageSize);
  },

  methods: {
    setDisabled(data) {
      this.disabled = data;
    },
    // 下拉刷新
    onRefresh() {
      this.refreshing = true;
      this.pageNum = 1;
      this.finished = false;
      this.getExpress(this.pageNum, this.pageSize);
    },
    onLoad() {
      this.pageNum += 1;
      this.getExpress(this.pageNum, this.pageSize);
    },
    async getExpress(pageNum, pageSize) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const { code, data } = await reqExpressList(pageNum, pageSize, this.fromBiliOrder);
      this.$toast.clear();
      if (code === 0) {
        if (this.refreshing) {
          this.expressList = [];
        }
        this.refreshing = false;
        this.loading = false;
        this.expressList = [...this.expressList, ...data.data];
        this.finished = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.myExpress {
  width: 100%;
  height: 100%;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #f9f9f9;

  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
  .handout-title {
    padding: 40px 0 0 40px;
    color: #333;
    font-weight: 800;
    font-size: 36px;
  }
  .logistics-list {
    padding: 0 40px 20px 40px;
    li {
      .time {
        padding: 40px 0 20px 0;
        color: #787878;
        font-size: 26px;
      }
    }
  }
}
</style>
